import { trunc } from '@trinity/chat-components/utils';
import { abbreviateNumber } from '@trinity/chat-components/utils/chart';

export type FormatAxisLabelOptions = {
  value: string | number;
  unit?: string;
  isPrefix?: boolean;
};

export function formatAxisLabel({ value, unit, isPrefix }: FormatAxisLabelOptions): string {
  const numeric = typeof value === 'number' ? value : parseFloat(String(value));
  let formattedValue: string;

  if (!isNaN(numeric)) {
    // Numeric axis tick — abbreviate by default (1450000 → 1.45M)
    formattedValue = abbreviateNumber(numeric);
  } else {
    // Category label — truncate long strings
    formattedValue = trunc(String(value), 10);
  }

  if (unit) {
    formattedValue = isPrefix ? `${unit}${formattedValue}` : `${formattedValue}${unit}`;
  }

  return formattedValue;
}
